<template>
  <div class="keyboard-shortcuts" style="display: none"></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      clipboard: [], // 复制剪切时存放元素的几个基本信息
      pasteTimes: 0, // 相同元素粘贴次数，用于控制定位
      isKeydown: false,
      selectedSprites: [],
      vKeydown: 0, // 0是未按下 1是按下 2是按下且执行过一次
    };
  },
  computed: {
    ...mapGetters([
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "TOOL",
      "isPreventDefault",
      "shortcutType",
    ]),
    ...mapGetters({
      'presentationShown': 'previewControls/layerShown'
    })
  },
  watch: {
    clipboard: {
      deep: true,
      handler(val) {
        this.pasteTimes = 0;
        if (val.length > 0) {
          this.$store.commit("toggle_isClipboardEmpty", false);
        } else {
          this.$store.commit("toggle_isClipboardEmpty", true);
        }
      },
    },
    "SelectScenes_Msg.id": function () {
      this.pasteTimes = -1;
    },
  },
  mounted() {
    document.addEventListener("paste", this.handlePasteAction, false);
    document.addEventListener(
      "copy",
      (ev) => {
        this.preventDefaultF(ev);
        if (ev.clipboardData) {
          ev.clipboardData.clearData();
          ev.clipboardData.setData("Text", "");
        }
        this.copy();
      },
      false
    );
    document.addEventListener(
      "cut",
      (ev) => {
        this.preventDefaultF(ev);
        if (ev.clipboardData) {
          ev.clipboardData.clearData();
          ev.clipboardData.setData("Text", "");
        }
        this.cut();
      },
      false
    );
    eve.on("windowOnblur", () => {
      this.isKeydown = false;
    });
    // 接收通过右键菜单发送过来的事件
    this.$bus.off("copy", this.copy);
    this.$bus.on("copy", this.copy);
    this.$bus.off("cut", this.cut);
    this.$bus.on("cut", this.cut);
    this.$bus.off("paste", this.paste);
    this.$bus.on("paste", this.paste);

    document.addEventListener(
      "keydown",
      (e) => {
        if (this.presentationShown) {
          return;
        }
        if (!this.isPreventDefault || this.isKeydown) return;
        e = e || window.event;
        let keyCode = e.keyCode || e.which || e.charCode;
        let ctrlKey = e.ctrlKey,
          metaKey = e.metaKey,
          shiftKey = e.shiftKey,
          altKey = e.altKey;
        // 阻止一直按键导致快捷键连续触发（撤销部分会出现问题--->没有根本解决）
        if (keyCode === 17 || keyCode === 91 || keyCode === 93 || shiftKey) {
          this.isKeydown = false;
        } else {
          !metaKey && (this.isKeydown = true);
        }
        if ((ctrlKey || metaKey) && !shiftKey) {
          // ctrl 组合键
          if (keyCode == 83) {
            // ctrl + s: 保存
            this.save();
            this.preventDefaultF(e);
          } else if (keyCode == 88) {
            // ctrl + x：剪切
            // this.cut();
            // console.log('this.cut');
            // this.preventDefaultF(e);
            if (ctrlKey || metaKey) return;
          } else if (keyCode == 67) {
            // ctrl + c：复制
            if (ctrlKey || metaKey) return;
          } else if (keyCode == 86) {
            // ctrl + v：粘贴
            if (ctrlKey || metaKey) {
              this.vKeydown = 1;
            }
            if (ctrlKey || metaKey) return;
          } else if (keyCode == 65) {
            e.preventDefault();
            // ctrl + a: 全选
            this.selectAll();
            this.preventDefaultF(e);
          } else if (keyCode == 90) {
            // ctrl + z：撤销
            this.$bus.emit("undo_redo_vue", { type: "undo" });
            this.preventDefaultF(e);
          } else if (keyCode == 89) {
            // ctrl + y：返回
            this.$bus.emit("undo_redo_vue", { type: "redo" });
            this.preventDefaultF(e);
          } else if (keyCode == 77) {
            // ctrl + m：居中
            this.center();
            this.preventDefaultF(e);
          } else if (keyCode == 76) {
            // ctrl + l: 单个选中的的元素锁定
            this.lockSprite();
            this.preventDefaultF(e);
          }
        } else if ((ctrlKey || metaKey) && shiftKey) {
          if (keyCode == 219) {
            this.preventDefaultF(e);
            this.setLayer("top");
          } else if (keyCode == 221) {
            this.preventDefaultF(e);
            this.setLayer("bottom");
          }
        } else if (shiftKey && !ctrlKey && !metaKey) {
          if (keyCode == 37) {
            // Left Arrow: 向左移动10px
            this.move(-10, 0);
            this.preventDefaultF(e);
          } else if (keyCode == 38) {
            // Up Arrow: 向上移动10px
            this.move(0, -10);
            this.preventDefaultF(e);
          } else if (keyCode == 39) {
            // Right Arrow: 向右移动10px
            this.move(10, 0);
            this.preventDefaultF(e);
          } else if (keyCode == 40) {
            // Down Arrow: 向下移动10px
            this.move(0, 10);
            this.preventDefaultF(e);
          }
        } else if (!ctrlKey && !metaKey && !shiftKey) {
          if (keyCode == 37) {
            // Left Arrow: 向左移动1px
            this.move(-1, 0);
            this.preventDefaultF(e);
          } else if (keyCode == 38) {
            // Up Arrow: 向上移动1px
            this.move(0, -1);
            this.preventDefaultF(e);
          } else if (keyCode == 39) {
            // Right Arrow: 向右移动1px
            this.move(1, 0);
            this.preventDefaultF(e);
          } else if (keyCode == 40) {
            // Down Arrow: 向下移动1px
            this.move(0, 1);
            this.preventDefaultF(e);
          } else if (keyCode == 46 || keyCode === 8) {
            // delete: 删除
            this.deleteKey();
            this.preventDefaultF(e);
          } else if (keyCode == 32) {
            this.spaceKey();
            this.preventDefaultF(e);
          } else if (keyCode == 27) {
            // esc
            this.$bus.emit("keycode_esc", { shortcutType: this.shortcutType });
            this.preventDefaultF(e);
          }
        }

        /**
         * isPreventDefault为true时阻止系统默认事件
         * this.$store.commit('toggle_isPreventDefault', true/false);
         */
      },
      false
    );
    document.addEventListener(
      "keyup",
      (e) => {
        e = e || window.event;
        let keyCode = e.keyCode || e.which || e.charCode;
        let ctrlKey = e.ctrlKey;
        let metaKey = e.metaKey;
        if (ctrlKey || metaKey || keyCode === 86) {
          this.vKeydown = 0;
        }
        this.isKeydown = false;
      },
      false
    );

    this.$bus.on("confirmAddVideo.goOn", this.basePaste);
  },
  beforeDestroy() {
    this.$bus.off("copy", this.copy);
    this.$bus.off("cut", this.cut);
    this.$bus.off("paste", this.paste);
    this.$bus.off("confirmAddVideo.goOn", this.basePaste);
  },
  methods: {
    handlePasteActionOuter(ev) {
      this.handlePasteAction(ev);
    },
    handlePasteAction(ev) {
      if (this.vKeydown === 2) {
        return;
      }
      this.vKeydown = 2; // 按下且执行一次
      this.preventDefaultF(ev);
      this.paste(ev);
      document.removeEventListener("paste", this.handlePasteActionOuter, false);
    },
    copy(ev) {
      // this.preventDefaultF(ev);
      if (this.shortcutType !== "editor") return;
      this.clipboard = [];
      this.saveToClipboard(this.SelectSprites_Msg, this.clipboard);
    },
    cut() {
      if (this.shortcutType !== "editor") return;
      let data = {
        id: this.SelectScenes_Msg.id,
        sprites: [],
        scale: this.TOOL.scale,
      };

      this.clipboard = [];
      this.saveToClipboard(this.SelectSprites_Msg, this.clipboard);
      this.SelectSprites_Msg.forEach((sprite) => {
        data.sprites.push(sprite.toJson(true));

        this.TOOL.removeSprite(sprite.id);
      });
      this.TOOL.selectSprite();

      eve("undo_redo", null, { type: "ctrlX", data: data });
    },
    basePaste(action) {
      if (this.shortcutType !== "editor") return;
      if (action !== "paste") {
        return;
      }
      this.pasteFromClipboard(this.clipboard);
    },
    paste(event) {
      if (this.shortcutType !== "editor") return;
      if (this.videoExist() && this.isVideoInClipboard()) {
        this.$modal.show("confirmAddVideo", {
          action: "paste",
        });
        return;
      }
      const clipboardData = event.clipboardData;
      if (clipboardData && clipboardData.items.length > 0) {
        this.pasteFromOuterClip(clipboardData);
      } else {
        this.pasteFromClipboard(this.clipboard);
      }
    },
    selectAll() {
      if (this.shortcutType !== "editor") return;
      let arr = [];
      this.TOOL.selectedScenes.sprites &&
        this.TOOL.selectedScenes.sprites.forEach((item) => {
          if (item.effect.pathAnim && item.effect.pathAnim.info) return;
          arr.push(item);
        });
      this.TOOL.selectSprite(arr);
    },
    center() {
      if (this.shortcutType !== "editor") return;
      if (this.SelectSprites_Msg.length !== 1) return;
      this.SelectSprites_Msg[0].update(
        {
          positionLeft:
            (this.TOOL.clientWidth - this.SelectSprites_Msg[0].width) / 2,
          positionTop:
            (this.TOOL.clientHeight - this.SelectSprites_Msg[0].height) / 2,
        },
        true
      );
    },
    deleteKey() {
      if (this.shortcutType !== "editor") {
        this.$bus.emit("keycode_delete", {
          shortcutType: this.shortcutType,
        });
        return;
      }
      let data = {
        id: this.SelectScenes_Msg.id,
        sprites: [],
        scale: this.TOOL.scale,
      };
      this.TOOL.selectedSprite.reduce((sequence, sprite) => {
        return sequence.then(() => {
          data.sprites.push(sprite.toJson(true));
          return this.TOOL.removeSprite(sprite.id);
        });
      }, Promise.resolve());

      // 删除完后清空选中，否则选中框还在
      this.TOOL.selectSprite();

      eve("undo_redo", null, { type: "ctrlDelete", data: data });
    },
    videoExist() {
      let scene = this.TOOL.selectedScenes;
      let sprites = scene.sprites || [];
      let bgType = scene.background.data.type;
      let videoBgExist = bgType === "Video";
      let videoSpriteExist = (sprites.filter((s) => s.type === "Video") || [])
        .length;
      let ret = videoBgExist || videoSpriteExist;

      return ret;
    },
    isVideoInClipboard() {
      return (
        this.clipboard &&
        this.clipboard.some((sprite) => sprite.type === "Video")
      );
    },
    saveToClipboard(sprites, clipboard) {
      if (!sprites) return;

      for (let i = 0; i < sprites.length; i++) {
        for (let j = 0; j < sprites.length - 1 - i; j++) {
          if (sprites[j].zIndex > sprites[j + 1].zIndex) {
            //相邻元素两两对比
            let temp = sprites[j + 1]; //元素交换
            sprites[j + 1] = sprites[j];
            sprites[j] = temp;
          }
        }
      }
      sprites.forEach((sprite) => {
        let spriteJson = sprite.toJson();
        spriteJson.copyId = sprite.id;
        clipboard.push(spriteJson);
        clipboard[clipboard.length - 1]._scale = this.TOOL.scale;
      });
    },
    pasteFromOuterClip(clipboardData) {
      let scenes = this.SelectScenes_Msg;
      let type = "";
      let option = {};
      let reg1 = /\/(gif|png|jpg|jpeg)$/i;
      let reg2 = /(gif|png|jpg|jpeg)$/i;
      // console.log('clipboardData.items', clipboardData.items);
      for (const item of clipboardData.items) {
        // console.log('reg1.test(item.type', reg1.test(item.type));
        if (reg1.test(item.type)) {
          // 判断图片尺寸
          const file = item.getAsFile();
          // 上传
          let arr = file.name.split(".");
          // console.log('reg2================>', arr);
          if (!reg2.test(arr[arr.length - 1])) {
            this.$message({
              showClose: true,
              message: "该文件格式不支持，请导入jpg、jpeg、png、gif格式的图片",
              type: "error",
            });
            return;
          }
          let type = "image";
          if (/\/(gif)$/i.test(item.type)) {
            type = "gif";
          }
          this.$bus.emit("upload-outer-pic", {
            type,
            file,
          });
        }
      }
    },
    async sizeExceeded(filesSize) {
      let resp = await this.$http.get("/api/user/material/size");
      if (resp.data.code === 200) {
        let { size: currentSize, maxSize } = resp.data.data;
        if (currentSize + filesSize > maxSize) {
          // this.$message({
          //   message: "文件超过可用空间大小，无法上传",
          //   type: "error",
          // });
          this.$memberGuide({
            show: true,
            context: this,
            funcRight: {
              type: "materialCapacity",
              name: "素材空间",
            },
          });
          return true;
        }
      }
      return false;
    },
    pasteFromClipboard(clipboard) {
      if (clipboard.length === 0) return;

      let groupList = [];
      for (let i = 0; i < clipboard.length; i++) {
        let spriteGroup = clipboard[i];
        if (spriteGroup.groupId && !(spriteGroup.groupId.id in groupList)) {
          let judgeGroup = true;

          for (let t = 0; t < groupList.length; t++) {
            let newGroup = groupList[t];
            if (newGroup.newData.id == spriteGroup.groupId.id) {
              judgeGroup = false;
              break;
            }
          }

          if (judgeGroup) {
            judgeGroup = Object.assign({}, spriteGroup.groupId);
            judgeGroup.id =
              spriteGroup.groupId.resourceId + "," + uuid.generate();
            groupList.push({
              id: spriteGroup.groupId.id,
              newData: judgeGroup,
            });
          }
        }
      }

      this.pasteTimes++;
      let scenes = this.SelectScenes_Msg;
      let scenesLength = this.SelectScenes_Msg.sprites.length;
      let tasks = [];
      let undoData = {
        scale: this.TOOL.scale,
        scenesId: scenes.id,
        sprites: [],
      };
      var getEasingName = function (num) {
        var map = ["linear", "easeOutExpo", "easeOutQuint"];
        return map[num] || 1;
      };
      var pathEasingMap = ["linear", "easeInOutQuad", "easeOutQuint"];
      clipboard.forEach((sprite) => {
        let option = {};
        option.url = sprite.url;
        option.id = sprite.id;
        option.resourceId = sprite.resourceId;
        option.fileType = sprite.fileType;
        option.groupId = sprite.groupId;
        option.copyId = sprite.copyId;
        option.trackingType = sprite.trackingType;

        if (sprite.groupId) {
          for (let i = 0; i < groupList.length; i++) {
            let newGroup = groupList[i];
            if (sprite.groupId.id == newGroup.id) {
              option.groupId = newGroup.newData;
            }
          }
        }
        if (sprite.sound) {
          option.sound = {
            url: sprite.sound.url,
            volume: sprite.sound.volume,
            duration: sprite.sound.duration,
          };
        }
        switch (sprite.type) {
          case "Text":
            option.text = sprite.text;
            var ffu = sprite.font.fontFamilyUrl || sprite.font.fontFamily || "";
            option.font = Object.assign({}, sprite.font, {
              fontFamilyUrl: ffu,
            });
            option.artStyle = sprite.artStyle;
            option.versionAnyway = sprite.versionAnyway || "Horizontal";
            option.artType = sprite.artType;
            option.letterSpacing = sprite.characterSpacing || 0;
            option.lineHeight = sprite.lineSpacing || 1;
            option.effectType = sprite.enterEffect.type || "Write";
            option.templateFree = sprite.templateFree || false;
            break;
          case "RichText":
            option.lineHeight = sprite.lineSpacing || 1;
            option.html = sprite.html;
            option.versionAnyway = sprite.versionAnyway || "Horizontal";
            option.fontList = sprite.fontList;
            option.resourceIds = sprite.resourceIds;
            break;
          case "Lottie":
            var OhttpL = option.url.indexOf("https://resources.laihua.com/");
            var ShttpL = sprite.url.indexOf("https://resources.laihua.com/");
            if (OhttpL === -1) {
              option.url = this.$handleAssetsUrl(option.url);
            }
            if (ShttpL === -1) {
              sprite.url = this.$handleAssetsUrl(sprite.url);
            }
            option.lottieOptions = {
              path: sprite.data || sprite.url,
              loop: 5,
            };
            option.isLoop =
              typeof sprite.isLoop === "boolean" ? sprite.isLoop : true;
            option.numberOfLoops =
              sprite.numberOfLoops === undefined ? 5 : sprite.numberOfLoops;
            break;
          case "Chart":
            var _style = JSON.parse(sprite.style || "{}"),
              _data = JSON.parse(sprite.data || "{}");
            option.chartOption = ChartSprite.chartFromJson({
              chartType: sprite.chartType,
              style: _style,
              data: _data,
            });
            option.data = _data;
            option.style = _style;
            option.chartType = sprite.chartType;
            option.scenesId = _this.id;
            break;
          case "Svg":
            option.fill = sprite.color;
            option.stroke = sprite.stroke;
            option.strokeWidth = sprite.strokeWidth;
            break;
          case "Gif":
            option.isLoop =
              typeof sprite.isLoop === "boolean" ? sprite.isLoop : true;
            option.numberOfLoops =
              sprite.numberOfLoops === undefined ? 5 : sprite.numberOfLoops;
            break;
          case "Frame":
          case "ImageFrame":
            sprite.type = "Frame";
            if (sprite.fillContent) {
              var fill = sprite.fillContent;
              option.picUrl = fill.url;
              option.picResourceId = fill.resourceId;
              option.picFileType = fill.fileType;
              option.matrix = {
                x: fill.offsetX,
                y: fill.offsetY,
                width: fill.width,
                height: fill.height,
                rotate: fill.rotation,
              };
            }
            break;
          case "Video":
            sprite.video;
            option.video = Object.assign({}, sprite.video, {
              loop: sprite.isLoop || false,
              repeatTimes:
                sprite.numberOfLoops === undefined ? 5 : sprite.numberOfLoops,
              startTime: sprite.videoStartTime,
              cutDuration: sprite.videoDuration,
              volume: sprite.volume,
              poster: sprite.poster,
            });
            option.thumbnailUrl = sprite.poster;
            option.userId = sprite.userId;
            break;
          case "Image":
            option.cropType = sprite.cropType;
            if (option.cropType)
              option.cropBoxData = Object.assign({}, sprite.cropData);
            break;
          default:
            break;
        }
        if (sprite.type === 'Video') {
          this.$bus.emit('pasteVideo', option);
          return;
        }
        tasks.push(
          this.TOOL.addSprite(sprite.type, option, scenes.id).then((s) => {
            let entranceEnd = 0;
            if (scenes.nowTime * 1000 + 500 >= scenes.duration) {
              entranceEnd = scenes.duration - 500;
            } else {
              entranceEnd = scenes.nowTime * 1000;
            }
            let outward = sprite.outward,
              hand = sprite.enterEffect.hand,
              exitHand = sprite.exitEffect.hand,
              attachAnim = sprite.stayEffect.attachAnim
                ? sprite.stayEffect.attachAnim[0]
                : null,
              animGraphs = sprite.stayEffect.animationGraphs
                ? sprite.stayEffect.animationGraphs[0]
                : null,
              _scale = sprite._scale / this.TOOL.scale;

            sprite.boxShadow && s.setShadow(sprite.boxShadow, "boxShadow");
            sprite.dropShadow && s.setShadow(sprite.dropShadow, "dropShadow");
            sprite.border && s.cropType !== "svg" && s.setBorder(sprite.border);
            sprite.filter && s.setFilter(sprite.filter);
            s.bgColor = sprite.bgColor || "";
            s.update({
              width: outward.width * _scale,
              height: outward.height * _scale,
              positionLeft: (outward.x + 20 * this.pasteTimes) * _scale,
              positionTop: (outward.y + 20 * this.pasteTimes) * _scale,
              rotate: outward.rotation,
              flip: outward.isFlipped,
              opacity: outward.opacity,
              backgroundColor: sprite.bgColor,
            });
            if (s.cropType === "svg") {
              s.cropSvgData(option.cropBoxData).then(() => {
                sprite.border && s.setBorder(sprite.border);
              });
            }
            if (s.cropType === "free") {
              s.cropBoxData.deltaRotation =
                s.cropBoxData.innerRotation - s.rotate;
            }
            s.updateEffect({
              // 入场动画
              code: sprite.enterEffect.type,
              direction: sprite.enterEffect.direction,
              easing: getEasingName(sprite.enterEffect.easing),
              drawingDuration:
                entranceEnd + sprite.enterEffect.drawDuration * 1000 >
                scenes.duration
                  ? scenes.duration - entranceEnd
                  : sprite.enterEffect.drawDuration * 1000,
              entranceAnim: {
                start: entranceEnd - 500,
                end: entranceEnd,
                hand: this.getHand(sprite, s),
                writehand: this.getHand(sprite, s),
              },
              // 出场动画
              exitAnim: {
                type: sprite.exitEffect.type,
                easing: getEasingName(sprite.exitEffect.easing),
                hand: exitHand
                  ? exitHand.url
                    ? {
                        x: exitHand.anchorPointX,
                        y: exitHand.anchorPointY,
                        url: handleAssetsUrl(exitHand.url),
                      }
                    : null
                  : null,
              },
              // 停留动画
              stayAnim: attachAnim
                ? Object.assign(
                    { type: attachAnim.type },
                    JSON.parse(attachAnim.data)
                  )
                : null,
              pathAnim: animGraphs
                ? {
                    type: animGraphs.type || "Path",
                    easing:
                      typeof animGraphs.easing === "number"
                        ? pathEasingMap[animGraphs.easing]
                        : "easeInOutQuad",
                    loop: animGraphs.loop,
                    start: entranceEnd,
                    end:
                      entranceEnd + animGraphs.duration * 1000 > scenes.duration
                        ? scenes.duration
                        : entranceEnd + animGraphs.duration * 1000,
                    target: {
                      x: animGraphs.toBounds.x * _scale,
                      y: animGraphs.toBounds.y * _scale,
                      w: animGraphs.toBounds.width * _scale,
                      h: animGraphs.toBounds.height * _scale,
                      rotate: animGraphs.toRotation,
                      opacity: animGraphs.toOpacity,
                      fillColor: animGraphs.toFillColor,
                      textColor: animGraphs.toTextColor,
                    },
                    info: animGraphs.info
                      ? {
                          width: animGraphs.info.width * _scale,
                          height: animGraphs.info.height * _scale,
                          rotate: animGraphs.info.rotate,
                          ccw: animGraphs.info.ccw,
                          path: s._scaleArr(animGraphs.path, _scale),
                        }
                      : null,
                    scale: editor.scale,
                  }
                : null,
              hand: hand
                ? hand.url
                  ? {
                      x: hand.anchorPointX,
                      y: hand.anchorPointY,
                      url: this.$unhandleAssetsUrl(hand.url),
                    }
                  : null
                : null,
            });

            undoData.sprites.push(s.toJson(true));
          })
        );
      });
      return Promise.all(tasks)
        .then(() => {
          // 粘贴后选中粘贴元素
          this.TOOL.selectSprite(
            this.TOOL.selectedScenes.sprites.slice(-this.clipboard.length)
          );
          this.$bus.emit("spritesFlagChange");
          eve("undo_redo", null, {
            type: "pasteFromClipboard",
            data: undoData,
          });
        })
        .then(() => {
          clipboard.forEach((sprite, i) => {
            this.SelectSprites_Msg.forEach((newSprite, t) => {
              if (sprite.copyId == newSprite.option.copyId) {
                let spriteIndex = scenesLength;
                if (i > 0) {
                  spriteIndex = spriteIndex + i;
                }
                this.TOOL.moveSpriteTo(newSprite.id, spriteIndex);
              }
            });
          });
        });
    },
    getHand(sData, sprite) {
      var drawhand = sData.enterEffect.hand;
      var writehand = sData.enterEffect.writehand;
      var url;
      if (sData.enterEffect.type === "Write") {
        url = (writehand || {}).url;
        if (writehand && writehand.resourceId && url) {
          url = this.$handleAssetsUrl(url);
        }
        return writehand && writehand.url
          ? Object.assign({}, writehand, {
              url: url,
            })
          : null;
      }
      return drawhand && drawhand.url
        ? {
            x: drawhand.anchorPointX,
            y: drawhand.anchorPointY,
            url: this.$handleAssetsUrl(drawhand.url),
          }
        : null;
    },
    save() {
      // 保存
      this.$bus.emit("save");
    },
    move(deltaX, deltaY) {
      if (this.shortcutType === "editor") {
        if (this.SelectSprites_Msg.length === 0) return;
        let undoData = {
          oldVal: [],
          val: [],
          scale: this.TOOL.scale,
          scenesId: this.SelectScenes_Msg.id,
        };
        this.SelectSprites_Msg.forEach((s) => {
          let oldM = {
            id: s.id,
            positionLeft: s.positionLeft,
            positionTop: s.positionTop,
            width: s.width,
            height: s.height,
            rotate: s.rotate,
          };

          let newM = Object.assign({}, oldM, {
            positionLeft: s.positionLeft + deltaX,
            positionTop: s.positionTop + deltaY,
          });

          undoData.oldVal.push(oldM);
          undoData.val.push(newM);
          s.update(newM);
        });
        if (this.SelectSprites_Msg.length === 1) {
          // 实时移动设置按钮
          this.$bus.emit("calcSpriteBtn");
        }
        eve("undo_redo", null, { type: "matrix", data: undoData });
      } else {
        this.$bus.emit("keycode_move", {
          shortcutType: this.shortcutType,
          x: deltaX,
          y: deltaY,
        });
      }
    },
    lockSprite() {
      if (this.SelectSprites_Msg.length !== 1) return;
      const s = this.SelectSprites_Msg[0];
      if (!s.locked) {
        s.setLocked(true);
        s.showHideHandle(true);
        this.$bus.emit("calcSpriteBtn");
        return;
      }
    },
    setLayer(action) {
      // 只负责置顶和置底
      if (this.SelectSprites_Msg.length <= 0) return;
      if (
        this.SelectScenes_Msg.sprites.length === this.SelectSprites_Msg.length
      )
        return;
      const undoData = {
        scenesId: this.SelectScenes_Msg.id,
        reData: [],
        data: [],
      };
      this.SelectSprites_Msg.sort((a, b) => {
        return a.zIndex - b.zIndex;
      });
      const ss = this.SelectSprites_Msg;
      const length = ss.length;
      const allSprites = this.SelectScenes_Msg.sprites;
      const len = allSprites.length;
      // 置顶默认
      let start = 0;
      let startS = len - length;
      if (action === "bottom") {
        start = length;
        startS = 0;
        // 已经置底直接退出
        if (ss[length - 1].index === length - 1) return;
      }
      // 已经置顶直接退出
      if (action === "top" && ss[0].index === startS) return;
      for (let i = 0, j = 0; i < len; i++) {
        const si = allSprites[i];
        undoData.reData.push({
          id: si.id,
          index: si.index,
        });
        if (ss.findIndex((s) => s.id === si.id) >= 0) {
          continue;
        }
        si.zIndex = start + j;
        si.setIndex(start + j);
        j++;
        undoData.data.push({
          id: si.id,
          index: si.index,
        });
      }
      for (let i = 0; i < length; i++) {
        ss[i].zIndex = startS + i;
        ss[i].setIndex(startS + i);
        undoData.data.push({
          id: ss[i].id,
          index: ss[i].index,
        });
      }
      allSprites.sort((a, b) => {
        return a.zIndex - b.zIndex;
      });
      eve("undo_redo", null, { type: "layerSetting", data: undoData });
    },
    arrayUnique(array) {
      // 数组去重
      // res用来存储结果
      let res = [];
      for (let i = 0, arrayLen = array.length; i < arrayLen; i++) {
        for (var j = 0, resLen = res.length; j < resLen; j++) {
          if (array[i].id === res[j].id) {
            break;
          }
        }
        // 如果array[i]是唯一的，那么执行完循环，j等于resLen
        if (j === resLen) {
          res.push(array[i]);
        }
      }
      return res;
    },
    judgeArrag() {
      let TooSelecrS = this.TOOL.selectedSprite,
        judgeData = false;
      this.selectedSprites;
      if (
        this.selectedSprites.length === TooSelecrS.length &&
        this.selectedSprites.length
      ) {
        for (let i = 0, arrayL = TooSelecrS.length; i < arrayL; i++) {
          if (TooSelecrS[i].id != this.selectedSprites[i].id) {
            judgeData = true;
            break;
          }
        }
      } else {
        judgeData = true;
      }
      return judgeData;
    },
    preventDefaultF(e) {
      if (this.isPreventDefault) {
        e.preventDefault();
        return false;
      }
    },
    spaceKey() {
      this.$bus.emit("keycode_space", {
        shortcutType: this.shortcutType,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Keyboard.vue